import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Card, Grid, Typography, CircularProgress } from "@mui/material";
import jobRoleImage from "../../../assets/images/unsplash_O453M2Liufs.png";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import Tabs from "../../../components/customTable/Tabs";
import { useNavigate } from "react-router-dom";
import { update } from "../../../slice/jobSlice";
import { useTQuery } from "../../../utils/useTQuery";
import { usePaginatedQuery } from "../../../utils/usePagination";
import { useInView } from 'react-intersection-observer';
import { TryOutlined } from "@mui/icons-material";

export default function PostedJobs({ tabName }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);

  const [activeTab, setActiveTab] = useState(tabName || "Upcoming");
  const [jobData, setJobData] = useState([]);
  const [customFetch, setCustomFetch] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.5, // Adjust this value if needed
  });

  // const { data, isLoading, refetch } = useTQuery(
  //   ["jobs", activeTab],
  //   `job/fetchfacilityJobStatus?ID=${userDetails?.ID}&tabDetail=${activeTab}`,
  //   "get",
  //   { enabled: false } // Disable automatic fetching
  // );
    const {
      fetchNextPage,
      data,
      refetch,
      hasNextPage,
      isFetchingNextPage,
      isLoading,
    } = usePaginatedQuery({
      queryKey: ["jobs", activeTab],

      url: `job/fetchfacilityJobStatus?ID=${userDetails?.ID}&tabDetail=${activeTab}&`,
      enabled: true,
      rowsPerPage:'10',
      parmeter:  { ID: userDetails?.ID, tabDetail: activeTab,}
    });


  const tabs = useMemo(() => ["Upcoming", "Ongoing", "Completed"], []);
  localStorage.removeItem("jobDate");

  useEffect(() => {
      if (!customFetch) {
        console.log("datadatadata",data?.pageParams.length)
        if (inView && hasNextPage && !isFetchingNextPage) {
          if (data?.pageParams.length  !== data.pages[0]?.meta?.totalPages) {
            console.log("datadatadata",data?.pageParams.length)
            fetchNextPage();
          }
        }
      } else {
        refetch()
        setCustomFetch(false)
      }
    }, [customFetch, inView, fetchNextPage, hasNextPage, isFetchingNextPage,]);

  const handleTabChange = useCallback(
    (tab) => {
      setActiveTab(tab);
    },
    [setActiveTab]
  );

  useEffect(() => {
    refetch();
  }, [activeTab, refetch]);

  // useEffect(() => {
  //   console.log("api get data: ", data?.OUTPUT)
  //   if (data?.STATUS) {
  //     setJobData(data.OUTPUT || []);
  //   } else {
  //     setJobData([]);
  //   }
  // }, [data]);

  // const renderJobCards = useCallback(() => {
  //   return data?.pages.flatMap(page => page.OUTPUT).map((job, index) => (
  //     <Grid item lg={5} key={index} >
  //       <Card
  //         sx={{ borderRadius: "8px", marginBottom: 2 }}
  //         onClick={() => {
  //           navigate("/facility/viewJob");
  //           dispatch(update({ ...job, MODE: "Edit", checkStatus: "offerAccept" }));
  //         }}
  //       >
  //         <Box
  //           sx={{
  //             margin: "0px",
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "center",
  //             marginBottom: "10px",
  //           }}
  //         >
  //           <img src={jobRoleImage} alt="" />
  //         </Box>
  //         <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>{job.specialty?.SPECIALTY_NAME}</Typography>
  //         <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }}>{job.jobs_role?.ROLE_NAME}</Typography>
  //         <Box sx={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
  //           <WorkOutlineOutlinedIcon sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }} />
  //           <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }} ml={1}>
  //             {job?.JOB_TYPE}
  //           </Typography>
  //         </Box>
  //         <Box sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
  //           <MonetizationOnOutlinedIcon sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }} />
  //           <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }} ml={1}>
  //             {`$${job.PAY_AMOUNT_FROM}-$${job.PAY_AMOUNT_TO}/hr`}
  //           </Typography>
  //         </Box>
  //         <Button
  //           sx={{
  //             color: "rgba(0,0,0,0.7)",
  //             fontSize: "12px",
  //             border: "1px solid rgba(0,0,0,0.3)",
  //             fontWeight: 600,
  //           }}
  //         >
  //           {job.specialty?.SPECIALTY_NAME}
  //         </Button>
  //         <Box
  //           sx={{
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "center",
  //             mt: 1.5,
  //           }}>
  //           <Typography

  //             sx={{
  //               color: "rgba(0,0,0,0.7)",
  //               fontSize: "12px",
  //               fontWeight: 500,
  //               cursor: "pointer",
  //               padding: "0px 1.5px"
  //             }}>
  //             {" "}
  //             <span className="loraFont">Posted on  {
  //               job.CREATED_DATE
  //                 ? `${new Date(job.CREATED_DATE).getDate()} ${new Date(job.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(job.CREATED_DATE).getFullYear()}`
  //                 : "Latest"
  //             }</span>
  //           </Typography>


  //           <Typography
  //             mt={1}
  //             sx={{

  //               color: "#3BB9E3",
  //               fontSize: "12px",
  //               fontWeight: 500,
  //               cursor: "pointer",
  //             }}>
  //             {" "}
  //             Job started date {
  //               job.SERVICE_DATE
  //                 ? `${new Date(job.SERVICE_DATE).getDate()} ${new Date(job.SERVICE_DATE).toLocaleString('default', { month: 'short' })} ${new Date(job.SERVICE_DATE).getFullYear()}`
  //                 : "Latest"
  //             }
  //           </Typography>
  //         </Box>
  //       </Card>
  //     </Grid>
  //   ));
  // }, [jobData, dispatch, navigate]);

  const renderJobCards = useCallback(() => {
    const jobs = data?.pages.flatMap(page => page.OUTPUT) || [];
  
    return jobs.map((job, index) => {
      const isLastElement = index === jobs.length - 1; // Correct reference to jobs array
  
      return (
        <Grid item lg={5} key={index} ref={isLastElement ? ref : null}>
          <Card
            sx={{ borderRadius: "8px", marginBottom: 2 }}
            onClick={() => {
              navigate("/facility/view-jobDetails");
              dispatch(update({ ...job, MODE: "Edit", checkStatus: "offerAccept" }));
    // return jobData.map((job, index) => (
    //   <Grid item lg={5} key={index}>
    //     <Card
    //       sx={{ borderRadius: "8px", marginBottom: 2 }}
    //       onClick={() => {
    //         navigate("/facility/view-jobDetails");
    //         dispatch(update({ ...job, MODE: "Edit", checkStatus: "offerAccept" }));
    //       }}
    //     >
    //       <Box
    //         sx={{
    //           margin: "0px",
    //           display: "flex",
    //           justifyContent: "space-between",
    //           alignItems: "center",
    //           marginBottom: "10px",
            }}
          >
            <Box
              sx={{
                margin: "0px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <img src={jobRoleImage} alt="" />
            </Box>
            <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
              {job.specialty?.SPECIALTY_NAME}
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }}>
              {job.jobs_role?.ROLE_NAME}
            </Typography>
             <Box sx={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
              <TryOutlined sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }} />
              <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }} ml={1}>
                {job?.HIRING_TYPE}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", marginTop: "3px" }}>
              <WorkOutlineOutlinedIcon sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }} />
              <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }} ml={1}>
                {job?.JOB_TYPE}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <MonetizationOnOutlinedIcon sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }} />
              <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }} ml={1}>
                {`$${job.PAY_AMOUNT_FROM}-$${job.PAY_AMOUNT_TO}/hr`}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
            <Button
              sx={{
                color: "rgba(0,0,0,0.7)",
                fontSize: "12px",
                border: "1px solid rgba(0,0,0,0.3)",
                fontWeight: 600,
              }}
            >
              {job.specialty?.SPECIALTY_NAME}
            </Button>

         
               <Button
               onClick={()=>navigate("/facility/view-jobDetails")}
              sx={{
                color: "#4eb3e8",
                fontSize: "12px",
                border: "1px solid #4eb3e8",
                fontWeight: 600,
               }}
            >
             View
            </Button>
          
            </Box>
          
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1.5 }}>
              <Typography
                sx={{
                  color: "rgba(0,0,0,0.7)",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                  padding: "0px 1.5px",
                }}
              >
                <span className="loraFont">
                  Posted on{" "}
                  {job.CREATED_DATE
                    ? `${new Date(job.CREATED_DATE).getDate()} ${new Date(job.CREATED_DATE).toLocaleString('default', { month: 'short' })} ${new Date(job.CREATED_DATE).getFullYear()}`
                    : "Latest"}
                </span>
              </Typography>
              <Typography
                mt={1}
                sx={{
                  color: "#3BB9E3",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Job started date{" "}
                {job.SERVICE_DATE
                  ? `${new Date(job.SERVICE_DATE).getDate()} ${new Date(job.SERVICE_DATE).toLocaleString('default', { month: 'short' })} ${new Date(job.SERVICE_DATE).getFullYear()}`
                  : "Latest"}
              </Typography>
            </Box>
          </Card>
        </Grid>
      );
    });
  }, [data, dispatch, navigate]); // Updated dependency to `data`
  
  return (
    <Box>
      {/* Tabs */}
      <Grid container spacing={1} mt={3}>
        {tabs.map((tab) => (
          <Grid item key={tab}>
            <Tabs title={tab} active={tab === activeTab} onClick={() => handleTabChange(tab)} />
          </Grid>
        ))}
      </Grid>

      {/* Loader */}
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center",  height: "60vh",
      width: "100%", }}>
          <CircularProgress />
        </Box>
      ) : (
       <Grid container spacing={2} mt={3}>
          {/* <Grid container pt={3} spacing={2}> */}
            {renderJobCards()}
          {/* </Grid> */}
         </Grid> 
      )}
    </Box>
  );
}
